(function () {
  'use strict';

  /* ── Helper: map field name to validation key ── */
  function getRuleKey(field) {
    var n = field.getAttribute('name') || '';
    if (n === 'contact[name]' || n === 'contact[Name]')  return 'name';
    if (n === 'contact[phone]' || n === 'contact[Phone number]') return 'phone';
    if (n === 'contact[email]') return 'email';
    if (n === 'contact[body]')  return 'message';
    /* Ask-an-expert uses a translated field name for message */
    if (field.tagName === 'TEXTAREA' && n.indexOf('contact[') === 0) return 'message';
    return null;
  }

  /* ── Validate a single field – returns error string or '' ── */
  function validateField(field) {
    var key = getRuleKey(field);
    if (!key) return '';
    var value = field.value.trim();

    /* --- Name --- */
    if (key === 'name') {
      if (value === '') return 'Name is required';
      if (!/^[A-Za-z\s]+$/.test(value)) return 'Name must contain only letters';
      if (value.length < 2 || value.length > 50) return 'Name must be between 2–50 characters';
    }

    /* --- Phone Number (India) --- */
    if (key === 'phone') {
      if (value === '') return 'Phone number is required';
      if (!/^\d+$/.test(value)) return 'Enter valid 10-digit mobile number';
      if (!/^[6-9]/.test(value)) return 'Phone number must start with 6,7,8, or 9';
      if (value.length !== 10) return 'Enter valid 10-digit mobile number';
    }

    /* --- Email --- */
    if (key === 'email') {
      if (value === '') return 'Email is required';
      if (/\s/.test(value)) return 'Invalid email format';
      if (!/^[a-zA-Z0-9._%+\-]+@[a-zA-Z0-9.\-]+\.[a-zA-Z]{2,}$/.test(value)) return 'Enter valid email address';
    }

    /* --- Message --- */
    if (key === 'message') {
      if (value === '') return 'Message cannot be empty';
      if (value.length < 5) return 'Message must be at least 5 characters';
      if (value.length > 500) return 'Message must not exceed 500 characters';
    }

    return '';
  }

  /* ── Show / clear inline error below a field ── */
  function showFieldError(field, message) {
    var wrapper = field.closest('.form-field');
    if (!wrapper) return;

    var errorEl = wrapper.querySelector('.contact-field-error');

    if (message) {
      field.classList.add('input--error');
      wrapper.classList.add('form-field--error');
      if (!errorEl) {
        errorEl = document.createElement('div');
        errorEl.className = 'contact-field-error';
        wrapper.appendChild(errorEl);
      }
      errorEl.textContent = message;
    } else {
      field.classList.remove('input--error');
      wrapper.classList.remove('form-field--error');
      if (errorEl) {
        errorEl.remove();
      }
    }
  }

  /* ── Bind validation to a single contact form ── */
  function initForm(form) {
    if (form.dataset.contactValidationBound) return;
    form.dataset.contactValidationBound = 'true';

    var fields = form.querySelectorAll('input[name^="contact["], textarea[name^="contact["]');

    /* Live validation: blur → show error, input → clear when corrected */
    fields.forEach(function (field) {
      field.addEventListener('blur', function () {
        showFieldError(field, validateField(field));
      });
      field.addEventListener('input', function () {
        if (field.classList.contains('input--error')) {
          showFieldError(field, validateField(field));
        }
      });
    });

    /* Submit gate – prevent submission until every field is valid */
    form.addEventListener('submit', function (e) {
      var hasError = false;

      fields.forEach(function (field) {
        var msg = validateField(field);
        showFieldError(field, msg);
        if (msg) hasError = true;
      });

      if (hasError) {
        e.preventDefault();
        e.stopImmediatePropagation();
        var firstErr = form.querySelector('.form-field--error');
        if (firstErr) {
          firstErr.scrollIntoView({ behavior: 'smooth', block: 'center' });
        }
      }
    });
  }

  /* ── Bootstrap ── */
  function init() {
    document.querySelectorAll('form.contact-form').forEach(initForm);

    if (typeof MutationObserver !== 'undefined') {
      new MutationObserver(function (mutations) {
        mutations.forEach(function (m) {
          m.addedNodes.forEach(function (node) {
            if (node.nodeType === 1) {
              if (node.matches && node.matches('form.contact-form')) {
                initForm(node);
              }
              var inner = node.querySelectorAll ? node.querySelectorAll('form.contact-form') : [];
              inner.forEach(initForm);
            }
          });
        });
      }).observe(document.body, { childList: true, subtree: true });
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
